import { render } from "./FilesView.vue?vue&type=template&id=aa0d1c9a&scoped=true&ts=true"
import script from "./FilesView.vue?vue&type=script&lang=ts"
export * from "./FilesView.vue?vue&type=script&lang=ts"

import "./FilesView.vue?vue&type=style&index=0&id=aa0d1c9a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa0d1c9a"]])

export default __exports__